export default __webpack_public_path__ + "static/media/profile-img@2x.06885274.png";